import { defineComponent, h, nextTick } from 'vue';
import { QTabs, QTab, QIcon } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';
import utils from '../../Shared/utils.jsx';
import EventBus from '../event-bus.js';

//Vue.component('dynamic-tab', {
export default defineComponent({
    name: 'dynamic-tab',
    components: { QTabs, QTab, QIcon },
    mixins: [BaseComponent],
    data: function () {
        return {
            sourceraw: null,
            sourceurl: null,
            model: null,
            tab_state: {
                index: 0
            },
            selected_tab_expr: null,
            selectionHistory: [],
            /** While true, SelectedTab watcher must not call changeTab (avoids double run after QTabs emit updates the bound index). */
            _suppressSelectedTabWatcherRecursion: false,
        }
    },
    async created() {
        if (this.controlData.ActiveTabIndex)
            this.selected_tab_expr = utils.compileExpression(this, this.controlData.ActiveTabIndex);

        if (this.controlData.SourceType === 'Raw' && this.controlData.SourceRaw) {
            this.sourceraw = utils.compileObject(this, this.controlData.SourceRaw);
        }
        else if (this.controlData.SourceType === 'Url' && this.controlData.SourceUrl) {
            this.sourceurl = utils.compile(this, this.controlData.SourceUrl);
        }

        if (this.controlData.ListenForTabEvents) {
            EventBus.$on('Action-Tab', this.openTabAction);
            EventBus.$on('Action-RenameTab', this.performRenameTab);

            if (this.controlData.Name) {
                // Subscribe by name so Target can be directed to a specific control
                EventBus.$on(`Action-Tab:${this.controlData.Name}`, this.openTabAction);
                EventBus.$on(`Action-RenameTab:${this.controlData.Name}`, this.performRenameTab);
            }
        }

        this.$on('Action-Close', this.closeTabAction);

        // Subscribe by name so Target can be directed to a specific control
        if (this.controlData.Name)
            this.$on(`Action-Close:${this.controlData.Name}`, this.closeTabAction);
    },
    unmounted() {
        if (this.controlData.ListenForTabEvents) {
            EventBus.$off('Action-Tab', this.openTabAction);
            EventBus.$off('Action-RenameTab', this.performRenameTab);

            if (this.controlData.Name) {
                // Subscribe by name so Target can be directed to a specific control
                EventBus.$off(`Action-Tab:${this.controlData.Name}`, this.openTabAction);
                EventBus.$off(`Action-RenameTab:${this.controlData.Name}`, this.performRenameTab);
            }
        }

        this.$off('Action-Close', this.closeTabAction);

        // Subscribe by name so Target can be directed to a specific control
        if (this.controlData.Name)
            this.$off(`Action-Close:${this.controlData.Name}`, this.closeTabAction);

    },
    //Mounted Replaced with preRenderComplete
    computed: {
        SelectedTab: function () {
            if (this.selected_tab_expr)
                return utils.evaluate(this.selected_tab_expr, this);
            else
                return -1;
        },
        ActiveTabIndex: {
            get: function () {
                return this.SelectedTab;
            },
            set: function (index) {
                this.changeTab(index);
            }
        },
        Menus: function () {
            return utils.document_cache.menus;
        },
    },
    watch: {
        // whenever selected_tab_expr changes, this function will run
        SelectedTab: function (newValue, oldValue) {
            utils.log(`DynamicTab ${this.name} SelectedTab changed from ${oldValue} to ${newValue}`);

            if (this._suppressSelectedTabWatcherRecursion)
                return;

            // Route already matches this tab: RouterCurrentPath watcher (or prior changeTab) handled actions; avoid duplicating.
            if (this.controlData.UseRouter && 'RouterCurrentPath' in this && this.model?.length > 0) {
                const idx = typeof newValue === 'string' ? parseInt(newValue, 10) : newValue;
                if (typeof idx === 'number' && idx >= 0 && idx < this.model.length) {
                    const suffix = `#/${this.controlData.RoutingName}/${this.model[idx].$objectid}`;
                    if (this.RouterCurrentPath.endsWith(suffix))
                        return;
                }
            }

            if (typeof newValue === 'string')
                this.changeTab(parseInt(newValue));
            else
                this.changeTab(newValue);
        },
        RouterCurrentPath: function (newVal, oldVal) {
            if (this.controlData.UseRouter) {
                var rgx = new RegExp(`${this.controlData.RoutingName}/([^/]*)`, 'ig');
                var matches = [...newVal.matchAll(rgx)];

                if (matches[0] && matches[0].length >= 2) {
                    utils.debug(`Tab newVal: ${newVal}; oldVal: ${oldVal};`);
                    var index = this.model.findIndex(o => o.$objectid == matches[0][1]);
                    //setDynamicTab
                    utils.executeAndCompileAllActions(this.controlData.Actions, { Data: index }, this);
                }
            }
        }
    },
    methods: {
        async preRenderComplete() {
            await this.Refresh();
            this.finishRenderHandler(this);
        },
        async Refresh() {
            if (this.sourceraw)
                try {
                    this.model = utils.evaluateObject(this.sourceraw, this);
                }
                catch (e) {
                    utils.warn('DynamicTab failed to evaluate SourceRaw ' + this.controlData.SourceRaw + ': ' + e);
                }
            else if (this.sourceurl)
                try {
                    this.model = await utils.api.get(utils.evaluate(this.sourceurl, this));
                }
                catch (e) {
                    utils.warn('DynamicTab failed to evaluate SourceUrl ' + this.controlData.SourceUrl + ': ' + e);
                }
        },
        async changeTab(index) {
            this._suppressSelectedTabWatcherRecursion = true;
            try {
                utils.log(`DynamicTab ${this.name} changeTab(index:${index})`);
                utils.hideAllTooltipsNow();

                if (index === -1) {
                    await utils.executeAndCompileAllActions(this.controlData.Actions, { Data: index }, this);
                    return;
                }

                if (this.model?.length > 0) {
                    if (this.controlData.UseRouter && 'RouterCurrentPath' in this) {
                        if (!this.RouterCurrentPath.endsWith(`#/${this.controlData.RoutingName}/${this.model[index].$objectid}`))
                            this.RouterPush(`#/${this.controlData.RoutingName}/${this.model[index].$objectid}`);
                        else
                            await utils.executeAndCompileAllActions(this.controlData.Actions, { Data: index }, this);
                    }
                    else {
                        if (this.selectionHistory[this.selectionHistory.length - 1] != this.model[index].$objectid)
                            this.selectionHistory.push(this.model[index].$objectid);

                        await utils.executeAndCompileAllActions(this.controlData.Actions, { Data: index }, this);
                    }
                }
            }
            finally {
                await nextTick();
                this._suppressSelectedTabWatcherRecursion = false;
            }
        },
        SetActiveTabIndex(index) {
            if (index !== this.SelectedTab)
                this.changeTab(index);
        },
        async closeTab(e, index) {
            if (e) {
                e.cancelBubble = true;
                e.stopPropagation();
            }

            utils.log(`DynamicTab ${this.name} closeTab(index:${index})`);

            var routingIndex = -1;

            if (this.controlData.UseRouter && 'RouterCurrentPath' in this) {
                var rgx = new RegExp(`${this.controlData.RoutingName}/([^/]*)`, 'ig');
                var matches = [...this.RouterCurrentPath.matchAll(rgx)];

                if (matches[0] && matches[0].length >= 2)
                    routingIndex = this.model.findIndex(o => o.$objectid == matches[0][1]);
            }

            //closeTab
            await utils.executeAndCompileAllActions(this.controlData.CloseActions, { Data: index }, this);

            //Navigate
            if (this.controlData.UseRouter && 'RouterCurrentPath' in this) {
                if (routingIndex == index)
                    this.RouterGo(-1);
                else {
                    var rgx = new RegExp(`${this.controlData.RoutingName}/([^/]*)`, 'ig');
                    var matches = [...this.RouterCurrentPath.matchAll(rgx)];

                    if (matches[0] && matches[0].length >= 2) {
                        var newIndex = this.model.findIndex(o => o.$objectid == matches[0][1]);
                        await utils.executeAndCompileAllActions(this.controlData.Actions, { Data: newIndex }, this);
                    }
                }
            }
            else {
                //set old to navigate to it on next tick
                var old = -1;

                if (this.model && this.model.length) {
                    for (var i = this.selectionHistory.length - 1; i >= 0; i--) {
                        var tab = this.model.findIndex(o => o.$objectid == this.selectionHistory[i]);

                        if (tab != -1 && tab != index - 1) {
                            old = tab;
                            this.selectionHistory.splice(i);
                            break;
                        }
                    }
                }

                const c = this;
                nextTick(() => {
                    if (old >= index) {
                        utils.executeAndCompileAllActions(this.controlData.Actions, { Data: old - 1 }, c);
                    }
                });
            }
        },

        async performRenameTab(action) {
            utils.log(`DynamicTab RenameTab ${action.ActionData.TabTitle}`);

            if (action.ActionData && action.ActionData.Debug && action.ActionData.Debug.BreakPoint) debugger;

            if (action.tabtitle) {
                const title = utils.evaluate(action.tabtitle, action.context);

                await utils.executeAndCompileAllActions(this.controlData.RenameActions, { TabTitle: title, Index: this.SelectedTab }, this);

                try {
                    await utils.complete(action);
                }
                catch (e) { }

                // Complete the promise for the executeAction method
                action.FinishFunc(true);
            }
        },
        async openTabAction(action) {
            utils.log(`DynamicTab openTabAction`);

            if (action.ActionData && action.ActionData.Debug && action.ActionData.Debug.BreakPoint) debugger;

            if (action.ActionData) {
                if (action.actiondatafunc) {
                    if (!action.context.$attrs) action.context.$attrs = {};

                    action.context.$attrs['paramData'] = utils.evaluateObject(action.actiondatafunc, action.context);
                }

                // Clone the action's ControlData so we get a full copy, with no duplicate references
                const controlData = JSON.parse(JSON.stringify(action.ActionData.ControlData));

                // Evaluate the ControlData.Vars here (still using action.context rather than this...)
                // Note that action.vars also exists and resolves the same as action.varsobj - no difference
                if (action.varsobj) {
                    controlData.Vars = utils.evaluateObject(action.varsobj, action.context);
                    controlData.$nointerp = true;
                }

                const act = {
                    Name: action.ActionData.Name,
                    TabID: action.tabID ? utils.evaluate(action.tabID, action.context) : '',
                    TabTitle: action.tabTitle ? utils.evaluate(action.tabTitle, action.context) : '',
                    ActionData: action.context.$attrs ? (action.context.$attrs['paramData'] || {}) : {},
                    ControlData: controlData,
                    OnActivateActions: action.ActionData.OnActivateActions || [],
                    OnDeactivateActions: action.ActionData.OnDeactivateActions || [],
                    context: action.context,
                };

                await utils.executeAndCompileAllActions(this.controlData.OpenActions, { Data: act }, this);

                var index = this.model.findIndex(o => o.ID == act.TabID);

                utils.hideAllTooltipsNow();
                await this.changeTab(index);

                try {
                    await utils.complete(action);
                }
                catch (e) { }

                // Complete the promise for the executeAction method
                action.FinishFunc(true);
            }
        },
        async closeTabAction(action) {
            // This handles the Close action which is emitted by UIAction_Close, which is typically broadcast from a child
            utils.log(`DynamicTab closeTabAction index:${this.SelectedTab}`);

            if (action.ActionData.Debug && action.ActionData.Debug.BreakPoint) debugger;

            await this.closeTab(null, this.SelectedTab);
        },
    },
    props: {
    },
    render() {
        if (!this.todisplay || !this.controlData)
            return null;

        let items = [];

        const useDark = this.controlData.DarkTheme || false;

        let bgcolor;
        if (this.controlData.StyleHints && this.controlData.StyleHints.BackgroundColor)
            bgcolor = this.controlData.StyleHints.BackgroundColor;

        let fgcolor;
        if (this.controlData.StyleHints && this.controlData.StyleHints.ForegroundColor)
            fgcolor = this.controlData.StyleHints.ForegroundColor;

        if (this.model) {
            for (let tabi = 0; tabi < this.model.length; tabi++) {
                const tab = this.model[tabi];
                if (!tab.$objectid)
                    tab.$objectid = utils.generateUUID();

                if (tab.Icon && tab.Icon.includes('{'))
                    tab.Icon = 'mdi mdi-phone';

                if (!tab.ID)
                    tab.ID = utils.generateUUID();

                let tooltip = tab.Tooltip;

                let icon;
                let title = tab.Title;
                if (title.length > 25) {
                    title = title.substr(0, 25) + '...';
                    if (!tooltip)
                        tooltip = tab.Title;
                }

                const iconName = tab.Icon ? String(tab.Icon).replace(/^\s*mdi\s+/, '').trim() || tab.Icon : null;
                if (tooltip) {
                    if (tab.Icon)
                        icon = utils.tt(tooltip, <QIcon name={iconName} size="xs" />);

                    title = utils.tt(tooltip, <span>{title}</span>, 'bottom');
                }
                else {
                    if (tab.Icon)
                        icon = <QIcon name={iconName} size="xs" />;
                }

                let closeicon;
                if (this.controlData.ShowCloseIcon)
                    closeicon = (
                        <QIcon name="mdi-close-circle" size="xs" class="q-ml-sm"
                            onMousedown={(e) => e.stopPropagation()}
                            onClick={(e) => this.closeTab(e, tabi)} />
                    );

                closeicon = utils.generateTooltip(h, closeicon, 'Close', 'end');

                items.push(
                    <QTab key={tab.ID}
                        name={tabi}
                        class="text-capitalize"
                        style={bgcolor || fgcolor ? { backgroundColor: bgcolor, color: fgcolor } : undefined}
                        onMousedown={() => {
                            if (tabi == this.SelectedTab)
                                void this.changeTab(tabi);
                        }}
                        onAuxclick={(e) => {
                            // button 1 is the middle mouse button
                            if (e.button === 1) {
                                e.preventDefault();
                                this.closeTab(e, tabi);
                            }
                        }}>
                        <span>
                            {icon}
                            {title}
                            {closeicon}
                        </span>
                    </QTab>
                );
            }
        }

        return (
            <QTabs
                align="left"
                outside-arrows
                mobile-arrows
                class={{ 'c-DynamicTab': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                style={{ ...this.sizeStyle, color: 'silver', maxWidth: '100%' }}
                activeColor={useDark ? 'white' : undefined}
                vertical={this.controlData.Orientation === 'Vertical'}
                modelValue={this.SelectedTab}
                onUpdate:modelValue={(v) => this.changeTab(v)}>
                {items}
            </QTabs>
        );
    }
});